module.exports = __webpack_public_path__ + "img/docx.5ffae543.png";